
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 11.667H7.5A.834.834 0 017.5 10H10a.834.834 0 010 1.667zm-3.333 2.5c0-.46.373-.834.833-.834h5a.833.833 0 110 1.667h-5a.834.834 0 01-.833-.833zm7.87 2.5H5.463c-.255 0-.463-.187-.463-.417V3.75c0-.23.208-.417.463-.417H10v2.625c0 1.31 1.014 2.375 2.262 2.375H15v7.917c0 .23-.207.417-.463.417zm-2.87-12.519l2.285 2.519h-1.69c-.329 0-.595-.318-.595-.709v-1.81zM16.45 6.94l-4.536-5a.833.833 0 00-.618-.273H5.463c-1.175 0-2.13.935-2.13 2.083v12.5c0 1.148.955 2.083 2.13 2.083h9.074c1.174 0 2.13-.935 2.13-2.083V7.5a.833.833 0 00-.217-.56z"}}),_c('mask',{attrs:{"id":"a","maskUnits":"userSpaceOnUse","x":"3","y":"1","width":"14","height":"18"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 11.667H7.5A.834.834 0 017.5 10H10a.834.834 0 010 1.667zm-3.333 2.5c0-.46.373-.834.833-.834h5a.833.833 0 110 1.667h-5a.834.834 0 01-.833-.833zm7.87 2.5H5.463c-.255 0-.463-.187-.463-.417V3.75c0-.23.208-.417.463-.417H10v2.625c0 1.31 1.014 2.375 2.262 2.375H15v7.917c0 .23-.207.417-.463.417zm-2.87-12.519l2.285 2.519h-1.69c-.329 0-.595-.318-.595-.709v-1.81zM16.45 6.94l-4.536-5a.833.833 0 00-.618-.273H5.463c-1.175 0-2.13.935-2.13 2.083v12.5c0 1.148.955 2.083 2.13 2.083h9.074c1.174 0 2.13-.935 2.13-2.083V7.5a.833.833 0 00-.217-.56z"}})])])
          )
        }
      }
    